<template>
  <div class="sidebar-left">
    <div class="sidebar">

      <!-- Logged In User Profile Sidebar -->
      <user-profile-sidebar
        :shall-show-user-profile-sidebar="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        @close-sidebar="$emit('update:shall-show-user-profile-sidebar', false)"
      />

      <!-- Sidebar Content -->
      <div
        class="sidebar-content"
        :class="{'show': mqShallShowLeftSidebar}"
      >

        <!-- Sidebar close icon -->
        <span class="sidebar-close-icon">
          <feather-icon
            icon="XIcon"
            size="16"
            @click="$emit('update:mq-shall-show-left-sidebar', false)"
          />
        </span>

        <!-- Header -->
        <div class="chat-fixed-search">
          <div class="d-flex align-items-center w-100">
            <!-- Search -->
            <b-input-group class="input-group-merge ml-1 w-100 round">
              <b-input-group-prepend is-text>
                <feather-icon
                  icon="SearchIcon"
                  class="text-muted"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="searchQuery"
                placeholder="Search..."
              />
            </b-input-group>

            <b-button
              variant="primary"
              class="ml-1 add-chat-btn"
              v-b-modal.modal-login
            >
              <feather-icon icon="PlusIcon" size="18" />
            </b-button>
          </div>
        </div>

        <b-modal
          id="modal-login"
          cancel-variant="outline-secondary"
          ok-title="send"
          cancel-title="Close"
          centered
          title="New Chat"
          @ok="AddNewChat"
          :ok-disabled="!phone_number"
        >
          <b-form>
            <b-form-group>
              <label for="email">Phone Number:</label>
              <b-form-input
                id="email"
                type="number"
                placeholder="852XXXXXXXX"
                v-model="phone_number"
              />
            </b-form-group>
          </b-form>
        </b-modal>

        <!-- ScrollArea: Chat & Contacts -->
        <vue-perfect-scrollbar
          ref="scrollRootEl"
          :settings="perfectScrollbarSettings"
          class="chat-user-list-wrapper list-group scroll-area"
        >

          <!-- Chats Title -->
          <h4 class="chat-list-title">
            Chats
          </h4>

          <ul class="chat-users-list chat-list media-list">
            <chat-contact
              v-for="contact in filteredChatsContacts"
              :key="contact.id"
              :user="contact"
              tag="li"
              :class="{'active': activeChatContactId === contact.id}"
              is-chat-contact
              @click="$emit('open-chat', contact)"
            />
            <li ref="sentinelEl" class="py-1 text-center">
              <small v-if="isLoading">Loading…</small>
              <small v-else-if="!hasMore">No more</small>
            </li>
          </ul>

        </vue-perfect-scrollbar>
      </div>

    </div>
  </div>
</template>

<script>
import {
  BAvatar, BInputGroup, BInputGroupPrepend, BFormInput,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { ref, onMounted, onBeforeUnmount, nextTick, watch } from '@vue/composition-api'
import ChatContact from './ChatContact.vue'
import UserProfileSidebar from './UserProfileSidebar.vue'
import { postRequest } from '../../../composables/axios.js'

export default {
  components: {

    // BSV
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,

    // 3rd party
    VuePerfectScrollbar,

    // SFC
    ChatContact,
    UserProfileSidebar,
  },
  props: {
    chatsContacts: {
      type: Array,
      required: true,
    },
    shallShowUserProfileSidebar: {
      type: Boolean,
      required: true,
    },
    profileUserData: {
      type: Object,
      required: true,
    },
    activeChatContactId: {
      type: Number,
      default: null,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    hasMore: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    const resolveChatContact = userId => props.contacts.find(contact => contact.id === userId)

    // Search Query
    const searchQuery = ref('')
    const filteredChatsContacts = ref([])
    //const filteredContacts = computed(() => props.contacts.filter(searchFilterFunction))
    const scrollRootEl = ref(null)   // your scroll container
    const sentinelEl = ref(null)
    let observer = null
    const phone_number = ref(null)
    
    onMounted(async () => {
      applyFilter()
      await nextTick()

      // ✅ for vue-perfect-scrollbar, the scrollable element is usually its $el
      const rootEl =
            scrollRootEl.value?.$el?.querySelector('.ps') ||
            scrollRootEl.value?.$el ||
            scrollRootEl.value

      observer = new IntersectionObserver(
        (entries) => {
          if (entries[0]?.isIntersecting) {
            if (!props.isLoading && props.hasMore) emit('load-more')
          }
        },
        {
          root: rootEl,
          rootMargin: '200px',
          threshold: 0,
        }
      )
      if (sentinelEl.value) observer.observe(sentinelEl.value)
    })

    onBeforeUnmount(() => {
      if (observer) observer.disconnect()
    })

    const normalize = v => String(v || '').replace(/\D/g, '')
    function applyFilter(f_text) {
      const q = normalize(f_text)

      if (!q) {
        filteredChatsContacts.value = props.chatsContacts
        return
      }

      console.log()

      filteredChatsContacts.value = props.chatsContacts.filter(c =>
        normalize(c.contact_number).includes(q)
      )
      console.log(filteredChatsContacts.value)
    }

    watch(searchQuery, (newVal,oldVal) => {
      applyFilter(newVal)
    })

    async function AddNewChat(){
      let cm_waba_id = 108224608741649
      let cm_phone_number_id = 110347678527933
      let rainbow_waba_id = 429471800258486
      let rainbow_phone_number_id = 491732857356103
      let cm_token = "ab1fe120f6c354897e462645890f869e4c3b27a8"
      let rainbow_token = "4b4a666ea63ecd4745f7a4ff52b1401876816b06"
      let payload = {
        waba_id: cm_waba_id,
        phone_number_id: cm_phone_number_id,
        recipient_phone: phone_number.value,
        template_id: 3252367071578418,
        by_admin: "cloudfit"               
      }
      let response = await postRequest("send_engagement_template",payload,cm_token)
      if(response.request.status == 200){
        phone_number.value = null
      } 
    }

    return {
      // Search Query
      searchQuery,
      filteredChatsContacts,
      //filteredContacts,
      scrollRootEl,
      sentinelEl,
      // UI
      resolveChatContact,
      perfectScrollbarSettings,
      phone_number,
      AddNewChat
    }
  }
}
</script>
